import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { OnboardingType } from './types';
import { useOnboardingData } from './integrationHooks';
import { useEffect, useMemo, useState } from 'react';
export var useMode = function useMode(_ref) {
  var CSPOnboardingEnabled = _ref.CSPOnboardingEnabled,
      CSPOnboardingOptions = _ref.CSPOnboardingOptions,
      isOnboardingDone = _ref.isOnboardingDone;

  var _ref2 = CSPOnboardingOptions !== null && CSPOnboardingOptions !== void 0 ? CSPOnboardingOptions : {},
      isCspOnboardingSliderDisabled = _ref2.isCspOnboardingSliderDisabled,
      isCspMegaMenuDisabled = _ref2.isCspMegaMenuDisabled,
      isCspMegaMenuAutoOpenDisabled = _ref2.isCspMegaMenuAutoOpenDisabled,
      forceMode = _ref2.forceMode;

  var defaultResponse = {
    onboardingType: OnboardingType.none,
    autoOpen: false,
    initialSlide: 0
  };

  var _useState = useState(defaultResponse),
      _useState2 = _slicedToArray(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];

  var disabled = !CSPOnboardingEnabled || !!forceMode;
  var result = useOnboardingData({
    skip: disabled
  });
  var loading = result.loading,
      error = result.error,
      data = result.data;
  var isSliderEligibleWithParams = useMemo(function () {
    return isSliderEligible(isCspOnboardingSliderDisabled, isOnboardingDone);
  }, [isCspOnboardingSliderDisabled, isOnboardingDone]);
  var isMegaMenuEligibleWithParams = useMemo(function () {
    return isMegaMenuEligible(isCspMegaMenuDisabled);
  }, [isCspMegaMenuDisabled]);
  var isMegaMenuAutoOpenEligibleWithParams = useMemo(function () {
    return isMegaMenuAutoOpenEligible(isCspMegaMenuAutoOpenDisabled);
  }, [isCspMegaMenuAutoOpenDisabled]);
  var transformData = pipe(isSliderEligibleWithParams, isMegaMenuEligibleWithParams, isMegaMenuAutoOpenEligibleWithParams);
  useEffect(function () {
    if (forceMode) {
      setMode(transformData(_objectSpread(_objectSpread({}, defaultResponse), forceMode)));
    } else {
      var _data$onboardingEligi;

      setMode(transformData((_data$onboardingEligi = data === null || data === void 0 ? void 0 : data.onboardingEligibility) !== null && _data$onboardingEligi !== void 0 ? _data$onboardingEligi : defaultResponse));
    }
  }, [loading, error, data, forceMode, isOnboardingDone, isCspOnboardingSliderDisabled, isCspMegaMenuDisabled, isCspMegaMenuAutoOpenDisabled]);
  return mode;
};

var isSliderEligible = function isSliderEligible(isCspOnboardingSliderDisabled, isOnboardingDone) {
  return function (response) {
    var onboardingType = response.onboardingType;
    var newOnboardingType = onboardingType;

    if ((isCspOnboardingSliderDisabled || isOnboardingDone) && (onboardingType === OnboardingType.slider || onboardingType === OnboardingType.sliderLive)) {
      newOnboardingType = onboardingType === OnboardingType.slider ? OnboardingType.megaMenu : OnboardingType.megaMenuLive;
    }

    return _objectSpread(_objectSpread({}, response), {}, {
      onboardingType: newOnboardingType
    });
  };
};

var isMegaMenuEligible = function isMegaMenuEligible(isCspMegaMenuDisabled) {
  return function (response) {
    var onboardingType = response.onboardingType;
    var newOnboardingType = onboardingType;

    if (isCspMegaMenuDisabled && (onboardingType === OnboardingType.megaMenu || onboardingType === OnboardingType.megaMenuLive)) {
      newOnboardingType = OnboardingType.none;
    }

    return _objectSpread(_objectSpread({}, response), {}, {
      onboardingType: newOnboardingType
    });
  };
};

var isMegaMenuAutoOpenEligible = function isMegaMenuAutoOpenEligible(isCspMegaMenuAutoOpenDisabled) {
  return function (response) {
    var onboardingType = response.onboardingType,
        autoOpen = response.autoOpen;
    var newAutoOpen = autoOpen;

    if (isCspMegaMenuAutoOpenDisabled && autoOpen && (onboardingType === OnboardingType.megaMenu || onboardingType === OnboardingType.megaMenuLive)) {
      newAutoOpen = false;
    }

    return _objectSpread(_objectSpread({}, response), {}, {
      autoOpen: newAutoOpen
    });
  };
};

export var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (arg) {
    return fns.reduce(function (prev, fn) {
      return fn(prev);
    }, arg);
  };
};